import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyAttendance extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={true} pageTitle={"Attendance" } formname={"table_77"} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyAttendance;